import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    studentName: "",
    studentClass: "",
    phone: "",
    email: "",
    tutorPreference: "",
    timeSlot: "",
    subjects: "",
    address: "",
    heardFrom: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await fetch("https://ihtbackend.onrender.com/send-contact-form", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
        setFormData({
          studentName: "",
          studentClass: "",
          phone: "",
          email: "",
          tutorPreference: "",
          timeSlot: "",
          subjects: "",
          address: "",
          heardFrom: "",
        });
      } else {
        setError(data.message || "An error occurred while submitting the form.");
      }
    } catch (err) {
      setError("Failed to send the form. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-8 bg-gradient-to-br from-blue-50 to-orange-50 shadow-2xl rounded-2xl mt-10 border border-orange-200">
      <h2 className="text-4xl font-bold text-center text-orange-600 mb-8">📞 Contact Us</h2>
      <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-5">
        {[
          { name: "studentName", placeholder: "Your Name" },
          { name: "studentClass", placeholder: "Class" },
          { name: "phone", placeholder: "Phone" },
          { name: "email", placeholder: "Email", type: "email" },
          { name: "tutorPreference", placeholder: "Tutor Preference" },
          { name: "timeSlot", placeholder: "Preferred Time Slot" },
          { name: "subjects", placeholder: "Subjects" },
          { name: "address", placeholder: "Address" },
          { name: "heardFrom", placeholder: "How Did You Hear About Us?" },
        ].map((field, idx) => (
          <input
            key={idx}
            type={field.type || "text"}
            name={field.name}
            value={formData[field.name]}
            onChange={handleChange}
            placeholder={field.placeholder}
            required={["studentName", "studentClass", "phone", "email"].includes(field.name)}
            className="w-full px-4 py-3 border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all duration-300 shadow-sm"
          />
        ))}

        <button
          type="submit"
          disabled={isSubmitting}
          className="bg-orange-600 hover:bg-orange-700 text-white py-3 px-6 rounded-lg font-semibold transition-all duration-300"
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
      </form>

      {success && (
        <p className="mt-6 text-green-600 font-semibold text-center">
          ✅ Form submitted successfully! We'll get back to you soon.
        </p>
      )}
      {error && (
        <p className="mt-6 text-red-600 font-semibold text-center">{error}</p>
      )}
    </div>
  );
};

export default Contact;
